import { VFC } from 'react'
import { getFirstDayOfNextMonth } from 'src/utils/dateUtils'
import styled from 'styled-components'

type MessageCountProps = {
  currentCount: number
  totalCount: number | null
  nextDate?: string
  className?: string
}

export const MessageCount: VFC<MessageCountProps> = ({
  currentCount,
  totalCount,
  nextDate = getFirstDayOfNextMonth(),
  className,
}) => {
  const isUnlimited = totalCount === 99999

  return (
    <MessageCountWrapper className={className} isUnlimited={isUnlimited}>
      {!isUnlimited && (
        <MessageCurrentCountWrapper>
          <span>残り</span>
          <MessageCurrentCount>{currentCount}</MessageCurrentCount>
          <span>通送信可能</span>
        </MessageCurrentCountWrapper>
      )}
      {isUnlimited ? (
        <UnlimitedPlanWrapper>
          <MessageCurrentCount>無制限</MessageCurrentCount>
        </UnlimitedPlanWrapper>
      ) : (
        <MessageNextCountWrapper>
          <span>（次回 {nextDate}に</span>
          <MessageNextCount>{totalCount}</MessageNextCount>
          <span>通付与予定）</span>
        </MessageNextCountWrapper>
      )}
    </MessageCountWrapper>
  )
}

const MessageCountWrapper = styled.div<{ isUnlimited?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isUnlimited }) => (isUnlimited ? 'center' : 'flex-start')};
  justify-content: ${({ isUnlimited }) =>
    isUnlimited ? 'center' : 'flex-start'};
  background: #ffffff;
  border: 1px solid #f6f6f6;
  border-radius: 12px;
  box-shadow: 2px 2px 8px 0px #0000001a;
  padding: 8px 16px 14px 16px;
  min-height: 64px;
`

const MessageCurrentCountWrapper = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 14px;
  color: #393e4c;
  margin-bottom: 8px;

  span {
    font-weight: normal;
  }
`

const MessageCurrentCount = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: #ff6c01;
  margin: 0 4px;
`

const MessageNextCountWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #808080;

  span {
    font-weight: normal;
  }
`

const MessageNextCount = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: #808080;
  margin: 0 4px;
`

const UnlimitedPlanWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`
